import { Form, InputNumber, Select, Space } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  isReadOnlyField,
  mergeNames,
  requiredField,
} from '@client/utils/form.util';
import { ECurrency } from '@common/types';

type TOriginalPriceProps = {
  disabled?: boolean;
  currencies?: (keyof typeof ECurrency)[];
  priceMin?: number;
  prefix?: string[];
  readOnlyFields?: string[];
};

export const OriginalPrice: React.FC<TOriginalPriceProps> = (props) => {
  const {
    disabled,
    currencies = [],
    priceMin = 0,
    prefix = [],
    readOnlyFields = [],
  } = props;

  const { t } = useTranslation();

  const originalPriceLabel = t('price.originalPrice');
  const currencyLabel = t('price.currency');

  return (
    <Form.Item label={originalPriceLabel}>
      <Space.Compact style={{ width: '100%' }}>
        <Form.Item
          noStyle
          name={mergeNames(prefix, 'currency')}
          rules={[requiredField(currencyLabel, true)]}
        >
          <Select
            style={{ width: 150 }}
            disabled={disabled || isReadOnlyField('currency', readOnlyFields)}
            options={currencies?.sort().map((type, idx) => ({
              key: idx,
              label: ECurrency[type],
              value: type,
            }))}
          />
        </Form.Item>
        <Form.Item
          noStyle
          name={mergeNames(prefix, 'originalPrice')}
          tooltip={requiredField(originalPriceLabel).message}
          rules={[requiredField(originalPriceLabel, true)]}
        >
          <InputNumber
            min={priceMin}
            style={{ width: '100%' }}
            placeholder={t('form.inputPlaceholder', {
              field: originalPriceLabel,
            })}
            readOnly={isReadOnlyField('originalPrice', readOnlyFields)}
            disabled={disabled}
          />
        </Form.Item>
      </Space.Compact>
    </Form.Item>
  );
};
